<template>
  <nuxt-layout>
    <section class="relative isolate overflow-hidden py-24 sm:py-32">
      <shape-field origin="center" />

      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div
          data-animate-group
          class="mx-auto max-w-3xl text-center"
        >
          <atomic-eyebrow :label="`Erreur ${error.statusCode}`" />

          <h1 class="mt-4 text-balance text-4xl font-display font-bold tracking-tight text-gray-900 sm:text-5xl">
            {{ title }}
          </h1>

          <p
            data-animate="fade-up"
            class="mt-6 text-pretty text-lg/8 text-gray-600"
          >
            {{ description }}
          </p>

          <div
            data-animate="fade-up"
            class="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <button-primary
              link="/"
              label="Retourner à l'accueil"
              size="lg"
              @click.prevent="clearError({ redirect: '/' })"
            />

            <button-secondary
              link="/contact"
              label="Contacter le support"
              size="lg"
              icon-name="ph:arrow-right"
            />
          </div>
        </div>
      </div>
    </section>

    <section-related-links :links="routingLinks" />
  </nuxt-layout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

type Props = {
  error: NuxtError
}

const { error } = defineProps<Props>()

const isNotFound = error.statusCode === 404

const title = isNotFound
  ? 'Page introuvable'
  : 'Problème technique'

const description = isNotFound
  ? 'Cette page n\'existe pas ou a été déplacée. Reprenez depuis l\'accueil ou par l\'une des pages ci-dessous.'
  : 'Une erreur technique est survenue de notre côté. Réessayez dans un instant ou contactez le support.'

const routingLinks = getCrossLinks(['fonctionnalites', 'tarifs', 'demo'])

useSeo({
  title: `${title} — ${appName}`,
  description: 'La page demandée est introuvable. Retournez à l\'accueil pour découvrir Live Display.',
  path: '/404',
  noIndex: true
})
</script>
